import React from "react";

// Friendly 404 for paths under reserved namespaces that match no real
// route. Bare /{slug} paths still reach the app — they may be storefronts.
export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-white px-6 text-center">
      <p className="text-7xl font-black text-brand">404</p>
      <h1 className="mt-4 text-xl font-bold">Página não encontrada</h1>
      <p className="mt-2 text-sm text-slate-400 max-w-sm">
        O endereço que procuras não existe ou foi movido.
      </p>
      <a
        href="/"
        className="mt-6 inline-flex items-center gap-2 rounded-xl bg-brand px-5 py-2.5 text-sm font-bold text-white hover:brightness-90 transition"
      >
        Voltar ao início
      </a>
    </div>
  );
}
